/**
 * vcardStore — dünne Lade-/Speicher-Helfer für die vCard-Pages (Backend, Spec §7.4).
 * Reine Delegation an VcardService; die http-Instanz entpackt `response.data`.
 */

import { VcardService } from './VcardService'
import { brandScope } from '../utils/scope'
import type { Session, Vcard, VcardInput } from '../types'

/** Lädt eine vCard über ihren urlKey (Editor der Admin-/Brand-Admin-Rolle). */
export async function loadVcard(urlKey: string): Promise<Vcard> {
  return VcardService.get(urlKey)
}

/** Speichert eine vCard (PUT-Replace). */
export async function saveVcard(urlKey: string, payload: VcardInput): Promise<void> {
  await VcardService.update(urlKey, payload)
}

/** Lädt die eigene vCard des eingeloggten Users. */
export async function loadMyVcard(): Promise<Vcard> {
  return VcardService.getMine()
}

/** Speichert die eigene vCard. */
export async function saveMyVcard(payload: VcardInput): Promise<void> {
  await VcardService.updateMine(payload)
}

/** Lädt die für die Session sichtbaren vCards (Listen-Seite, Spec §7.4). */
export async function loadVcards(session: Session): Promise<Vcard[]> {
  return VcardService.list(brandScope(session).scopedBrandParam())
}

/** Legt eine neue vCard an (nur Admin; Nutzerkonto entsteht serverseitig). */
export async function createVcard(payload: VcardInput): Promise<Vcard> {
  return VcardService.create(payload)
}

/** Schaltet die Sichtbarkeit einer vCard um (Spec §7.4). */
export async function setVcardActive(urlKey: string, active: boolean): Promise<Vcard> {
  return VcardService.setActive(urlKey, active)
}
